module.exports = __webpack_public_path__ + "static/fonts/fontello.a68f8e0.woff";


//////////////////
// WEBPACK FOOTER
// ./~/vue-goodshare/src/fonts/fontello.woff?88483298
// module id = 482
// module chunks = 15 16